"use client";

import brandlogo1 from "@/public/brandLogo/b1.svg";
import brandlogo2 from "@/public/brandLogo/b2.svg";
import brandlogo3 from "@/public/brandLogo/b3.svg";
import brandlogo4 from "@/public/brandLogo/b4.svg";
import brandlogo5 from "@/public/brandLogo/b5.svg";
import brandlogo6 from "@/public/brandLogo/b6.svg";
import brandlogo7 from "@/public/brandLogo/b7.svg";
import Image from "next/image";
import Animate from "@/components/Animate";
import { cmsUrl } from "@/app/config";

export default function FeatureBrands({ images }) {
  const brandList = [
    {
      id: 1,
      name: "Brand 1",
      image: brandlogo1,
    },
    {
      id: 2,
      name: "Brand 2",
      image: brandlogo2,
    },
    {
      id: 3,
      name: "Brand 3",
      image: brandlogo3,
    },
    {
      id: 4,
      name: "Brand 4",
      image: brandlogo4,
    },
    {
      id: 5,
      name: "Brand 5",
      image: brandlogo5,
    },
    {
      id: 6,
      name: "Brand 6",
      image: brandlogo6,
    },
    {
      id: 7,
      name: "Brand 7",
      image: brandlogo7,
    },
  ];

  if (Array.isArray(images) && images.length > 0) {
    return (
      <div>
        {" "}
        <ul className="flex flex-wrap gap-2  justify-center mt-[32px]">
          {images?.map((brandValue, index) => {
            console.log(brandValue);
            return (
              <li key={index} className="px-5 py-1  ">
                <Animate
                  animation="fadeIn"
                  duration={1}
                  threshold={0.4}
                  delay={index * 0.2}
                >
                  <Image
                    src={`${cmsUrl}/${brandValue?.image?.url}`}
                    width={157}
                    height={100}
                    alt={brandValue?.image?.alt}
                    className="w-[105px] md:w-[150px] h-[64px] object-contain"
                  />
                </Animate>
              </li>
            );
          })}
        </ul>
      </div>
    );
  } else {
    return (
      <div>
        {" "}
        <ul className="flex flex-wrap gap-2  justify-center mt-[32px]">
          {brandList?.map((brandValue, index) => {
            return (
              <li key={index} className="px-5 py-1  ">
                <Animate
                  animation="fadeIn"
                  duration={1}
                  threshold={0.4}
                  delay={index * 0.2}
                >
                  <Image
                    src={brandValue.image}
                    width={157}
                    height={100}
                    alt={brandValue.name}
                    className="w-[105px] md:w-[150px] h-[64px] object-contain"
                  />
                </Animate>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
